// export const base_url = "https://65.2.142.155:8000/api/";
// export const base_url = "http://localhost:5000/api/";
export const base_url = "https://lifeonplus.in/api/api/";

const getTokenFromLocalStorage = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;

export const config = {
  headers: {
    Authorization: `Bearer ${
      getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
    }`,
    Accept: "application/json",
  },
};
